<template src="./Campaigns.html"></template>
<script>

import mixins from "../../../../Mixins.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      selectedContract: "",
      selectedPlan: "",
      popupCampaign: false,
      idCompany: null,
      companyName: "",
      companies: [],
      campaigns: [],
      plans: [],
      doctorId: "",
      consultTaxSoftware: "",
      consultTaxNurse: "",
      taxCancelationPercentage: "",
      taxClinicPercentage: "",
      campaign: {
        name: "",
        contractId: "",
        companyId: "",
        webClinicId: ""
      },
      selectedCompanyOrClinic: "",
      titlePopUpCampaign: "",
      contracts: [],
      webClinics: [],
      invalidFields: {
        name: false,
        contract: false,
        clinic: false,
        company: false,
        plan: false,
        status: false,
        selectedCompanyOrClinic: false
      },
      isView: false,
    };
  },
  watch: {
    campaigns: function(newVal) {
      const vm = this;
      vm.campaigns = newVal;
    },
    selectedCompanyOrClinic: function(newVal) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(newVal) === false) {
        vm.invalidFields.selectedCompanyOrClinic = false;
      }
    },
    selectedContract: function(newVal) {
      this.changeContractValues(newVal);
    }
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;

      if (vm.$route.params.id) {
        vm.idCompany = 2;
        vm.doctorId = vm.$route.params.id;
        vm.getCampaigns();
        vm.getContract();
        vm.getPlans();
      }
    },
    changeContractValues(selectedContract) {
      const vm = this;
      vm.invalidFields.contract = false
      if (vm.testNullUndefinedEmpty(selectedContract)) return;
      vm.taxCancelationPercentage = Number.parseFloat(selectedContract.taxCancelationPercentage);
      vm.taxClinicPercentage = Number.parseFloat(selectedContract.taxClinicPercentage);
      vm.consultTaxNurse = Number.parseFloat(selectedContract.consultTaxNurse);
      vm.consultTaxSoftware = Number.parseFloat(selectedContract.consultTaxSoftware);

      vm.taxCancelationPercentage = (!Number.isNaN(vm.taxCancelationPercentage) && vm.taxCancelationPercentage != 0) ?
        vm.taxCancelationPercentage.toFixed(2)
        : (0.00).toFixed(2);

      vm.taxClinicPercentag = (!Number.isNaN(vm.taxClinicPercentage) && vm.taxClinicPercentage != 0) ?
        vm.taxClinicPercentage.toFixed(2)
        : vm.taxClinicPercentage = (0.00).toFixed(2);
      vm.consultTaxNurse = (!Number.isNaN(vm.consultTaxNurse) && vm.consultTaxNurse != 0) ?
        vm.consultTaxNurse.toFixed(2)
        : vm.consultTaxNurse = (0.00).toFixed(2);

      vm.consultTaxSoftware = (!Number.isNaN(vm.consultTaxSoftware) && vm.consultTaxSoftware != 0) ?
        vm.consultTaxSoftware.toFixed(2)
        : (0.00).toFixed(2);

      setTimeout(() => vm.$forceUpdate(), 200);
    },
    removeCampaign(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "campaign/" + id, {
          headers: { Authorization: vm.$session.get("bearerDefault") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlan();
          }
        });
    },
    getContractName(contractId) {
      const vm = this;
      let contract;
      let contractName = "";
      contract = vm.contracts.find(c => {
        return c.id === contractId;
      });
      if (!vm.testNullUndefinedEmpty(contract)) {
        contractName = contract.name;
      }
      return contractName;
    },
    validateFields() {
      const vm = this;
      let valid = true;
      if (vm.testNullUndefinedEmpty(vm.campaign.name)) {
        valid = false;
        vm.invalidFields.name = true;
      }
      if (vm.testNullUndefinedEmpty(vm.selectedContract)) {
        valid = false;
        vm.invalidFields.contract = true;
      }
      if (vm.campaign.active === null) {
        valid = false;
        vm.invalidFields.status = true;
      }
      if (valid == false) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Campos obrigatórios ou inválidos.",
          position: "top-right",
          color: "warning",
          icon: "error",
        });
      } else {
        if (vm.testNullUndefinedEmpty(vm.campaign.id)) {
          vm.saveNewCampaign();
        } else {
          vm.updateCampaign();
        }
      }
    },
    editCampaign(campaign) {
      const vm = this;
      vm.selectedContract = "";
      vm.selectedPlan = "";
      vm.isView = campaign.statusText !== 'Ativo' ;
      vm.titlePopUpCampaign = campaign.statusText === 'Ativo' ?
        "Editar modelo de contratação: " + campaign.contractName
        :"Visualizar modelo de contratação: " + campaign.contractName;
      (vm.invalidFields = {
        name: false,
        contract: false,
        clinic: false,
        company: false,
        plan: false,
        status: false,
        selectedCompanyOrClinic: false,
      }),
        vm.getCampaign(campaign.campaignId);
      vm.popupCampaign = true;
    },

    addNewCampaign() {
      let vm = this;
      vm.isView = false;
      vm.popupCampaign = true;
      vm.titlePopUpCampaign = "Novo modelo de contratação";
      vm.selectedCompanyOrClinic = "";
      vm.taxCancelationPercentage = "0,00";
      vm.taxClinicPercentage = "0,00";
      vm.consultTaxNurse = "0,00";
      vm.consultTaxSoftware = "0,00";
      vm.campaign = {
        name: "",
        contractId: "",
        companyId: "",
        webClinicId: "",
        active: false,
        doctorId:"",
      };
      vm.selectedContract = "";
      vm.selectedPlan = "";
    },
    saveNewCampaign() {
      const vm = this;

      vm.campaign.companyId = null;
      vm.campaign.contractId = vm.selectedContract.id;
      vm.campaign.customerPlanId = vm.selectedPlan.id;
      vm.campaign.doctorId = parseInt(vm.doctorId);
      vm.axios
        .post(vm.$store.state.filooServer + "campaign/", vm.campaign, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.popupCampaign = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Dados registrados com sucesso.",
              icon: "success",
            }).then(function () {
              vm.getCampaigns();
              vm.selectedContract = "";
            });
          }
        })
        .catch(function() {
          vm.popupCampaign = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível sallet o modelo de contratação" +
              vm.campaign.name +
              ". Por favor contacte o administrador do sistema.",
            icon: "error"
          });
        });
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/companies?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
          }
        });
    },
    getPlans() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan", {
          headers: { Authorization: vm.$session.get("bearerDefault") }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.plans = response.data;
          }
        });
    },
    updateCampaign() {
      const vm = this;
      vm.campaign.companyId = null;
      vm.campaign.doctorId = parseInt(vm.doctorId);
      vm.campaign.contractId = vm.selectedContract.id;
      vm.campaign.customerPlanId = vm.selectedPlan.id;

      vm.axios
        .put(vm.$store.state.filooServer + "campaign/", vm.campaign, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.popupCampaign = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Dados alterados com sucesso.",
              icon: "success",
            }).then(function() {
              vm.getCampaigns();
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getCampaign(campaignId) {
      const vm = this;
      let plan = "";
      let contract = "";
      vm.axios
        .get(
          vm.$store.state.filooServer + "campaign/find_by_id/" + campaignId,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.campaign = response.data;
            plan = vm.plans.find(p => {
              return p.id === vm.campaign.customerPlanId;
            });
            if (!vm.testNullUndefinedEmpty(plan)) {
              vm.selectedPlan = plan;
            }
            contract = vm.contracts.find(p => {
              return p.id === vm.campaign.contractId;
            });
            if (!vm.testNullUndefinedEmpty(contract)) {
              vm.selectedContract = contract;
            }
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível localizar o modelo de contratação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getContract() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "contract", {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function(response) {
          vm.contracts = response.data;
        });
    },
    getWebClinics() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "webclinics/getAll", {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          vm.webClinics = response.data;
        });
    },
    getCampaigns() {
      const vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer +
            "campaign/find_by_doctorId/" +
            vm.doctorId,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.campaigns = response.data;
            for (let c in vm.campaigns) {
              vm.campaigns[c].statusText =
                vm.campaigns[c].active === true ? "Ativo" : "Inativo";
            }
          }
        });
    },
    ispagible() {
      const vm = this;
      return vm.campaigns.length > 10;
    }
  }
};
</script>

<style lang="scss" src="./Campaigns.scss"></style>
